import React from 'react';
import { ShieldAlert } from 'lucide-react';

// Plain statement of where things stand. No compliance claims: the healthcare
// plan is not built, and the claims linter (scripts/check-claims.js) rejects
// HIPAA language and unscoped on-device claims on purpose.
const DataNote = () => {
  return (
    <section id="status" className="my-20">
      <div className="max-w-3xl mx-auto bg-apple-700/30 backdrop-blur-md rounded-3xl border border-apple-600/30 p-8 sm:p-10">
        <div className="flex items-start gap-4">
          <div className="shrink-0 w-10 h-10 rounded-xl bg-amber-400/10 flex items-center justify-center">
            <ShieldAlert className="text-amber-300" size={20} />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-apple-50 mb-3 tracking-tight">Where this stands today</h2>
            <p className="text-apple-200 leading-relaxed mb-4">
              Sortio today is a general file organizer for Mac, Windows, and Linux. By default it sends
              file names and folder paths to our cloud AI, and file contents only when a content feature
              is switched on. It also has a fully local mode (Ollama) and a bring-your-own-key mode where
              requests go straight from your machine to your own AI provider.
            </p>
            <p className="text-apple-200 leading-relaxed mb-4">
              The healthcare plan is being designed separately, around what practices tell us in these
              interviews. We are not announcing features, dates, or compliance claims until they are real.
              Until then we do not recommend pointing the current product at patient records.
            </p>
            <p className="text-amber-200/90 leading-relaxed">
              During research we do not want any patient information. Interviews are about the workflow:
              who does what, with which systems, and where the time goes. No names, no record contents.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataNote;
